import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import { getServiceAsync, DeleteFolderJsonResponse } from '../../service';
import { runOwsRequestWithMonitor, Feature, fullResponseOperationOption } from '../../shared';

export function hardDeleteFolder(id: string): Promise<DeleteFolderJsonResponse> {
    return getServiceAsync().then(service =>
        runOwsRequestWithMonitor({
            scenarioName: 'HardDeleteFolder',
            feature: Feature.FolderManagement,
            operation: () =>
                service.Operation.deleteFolderOperation(
                    {
                        Header: getJsonRequestHeader(),
                        Body: service.Factory.deleteFolderRequest({
                            DeleteType: 'SoftDelete',
                            FolderIds: [service.Factory.folderId({ Id: id })],
                        }),
                    },
                    fullResponseOperationOption
                ),
            transformResponse: response => response,
        })
    );
}
